import DefaultAttr from './default'
export default class Calendar extends DefaultAttr {
  constructor (args = {}) {
    super(args)
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/calendar.js